import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { ActionPayload, DataLakeMoveFileRequestInput } from '../gql-types.generated';

export const MUTATION_MOVE_FILE = gql`
    mutation moveDataLakeFile($input: DataLakeMoveFileRequestInput!){
        moveDataLakeFile(input: $input){
            message
            result
            errors {
                code
                message
            }
        }
    }
`;

export const mutationMoveDataLakeFile = async (
    client: ApolloClient<NormalizedCacheObject>,
    fileNamesWithFullPaths: string[],
    newDestinationPath: string
): Promise<ActionPayload | undefined> => {
    const { data, errors } = await client.mutate<{ moveDataLakeFile: ActionPayload }>({
        variables: { 
            input: {
                fileNamesWithFullPaths,
                destinationDirectoryFullPath: newDestinationPath
            } as DataLakeMoveFileRequestInput
         },
        mutation: MUTATION_MOVE_FILE
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // friendly error to user
        throw new Error('An error has occurred during the file move.');
    }
    if (data && data.moveDataLakeFile) {
        return data.moveDataLakeFile;
    }

    return undefined;
};